export const loadMedalliaFeedbackModal = formID => {
  window?.KAMPYLE_ONSITE_SDK?.loadForm(formID)
}

export const showMedalliaFeedbackModal = formID => {
  window?.KAMPYLE_ONSITE_SDK?.showForm(formID)
}

export const initMedallia = formID => {
  if (window.KAMPYLE_ONSITE_SDK) {
    loadMedalliaFeedbackModal(formID)
  } else {
    window.addEventListener("neb_OnsiteLoaded", () =>
      loadMedalliaFeedbackModal(formID)
    )
  }
}
